export default {
    importEmployeeData: 'Import Employee Data',
    importEmployee: 'Import Employee',
    importImage: 'Import Image',
    fileInput: 'File Input',
    msgUploadExcel: 'Upload your excel file',
    msgUploadZip: 'Upload your zip file',
    note: 'Note',
    msgImportExcel: 'Must be excel file type',
    msgImportImageA: 'Must be zip file type that size not exceed 500MB',
    msgImportImageB: 'Zip file must not include any folder',
    msgImportImageC: 'Only allowed image type jpeg/png in zip file',
    msgImportImageD: 'Each Image size must not exceed 200KB',
    submit: 'Submit',
    cancel: 'Cancel',
    close: 'Close',
    download: 'Download',
    importResultInfo: 'See more'
}
